export default __webpack_public_path__ + "static/jm-ed98083a77a07dc2ffa531c4477999c4.png";